var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatherPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.111,
    height: 25.156,
    viewBox: "0 0 25.111 25.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M25.277,19.586v3.335a2.223,2.223,0,0,1-2.423,2.223,22,22,0,0,1-9.594-3.413,21.678,21.678,0,0,1-6.67-6.67A22,22,0,0,1,3.177,5.423,2.223,2.223,0,0,1,5.389,3H8.724a2.223,2.223,0,0,1,2.223,1.912,14.274,14.274,0,0,0,.778,3.124,2.223,2.223,0,0,1-.5,2.346L9.814,11.793a17.787,17.787,0,0,0,6.67,6.67L17.9,17.052a2.223,2.223,0,0,1,2.346-.5,14.274,14.274,0,0,0,3.124.778,2.223,2.223,0,0,1,1.912,2.257Z",
    transform: "translate(-1.667 -1.5)",
    fill: "none",
    stroke: "#df5e60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherPhone);
export default __webpack_public_path__ + "static/media/feather-phone.817f51dec2eb39a97abf26ccdb5f8f4b.svg";
export { ForwardRef as ReactComponent };